module.exports = __webpack_public_path__ + "img/wallet-money.0924c658.svg";